import { Divider, Grid, Typography } from '@mui/material';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import {
  customerStyle,
  renderStatusCellDT,
  useStyles
} from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useSalesPartnerData } from '../../SalesPartnerData';

const BasicInfo = () => {
  const { salesPartner } = useSalesPartnerData();

  return (
    <>
      <div style={customerStyle.recentSearchStyle}>
        Sales Partner Basic Info
        {renderStatusCellDT(salesPartner.isActive || false)}
      </div>

      <Divider sx={customerStyle.divider} />

      <div style={{ width: '100%' }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h5" style={useStyles.formTitle}>
              Sales Partner Name
            </Typography>
            <VemigoTextFeild
              style={useStyles.readonlyFormControl}
              id="name"
              type="text"
              fullWidth
              readonly={true}
              counter={false}
              value={salesPartner?.name || ''}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant="h5" style={useStyles.formTitle}>
              Contact Number
            </Typography>
            <VemigoTextFeild
              style={useStyles.readonlyFormControl}
              id="contactNo"
              type="text"
              fullWidth
              readonly={true}
              counter={false}
              value={salesPartner?.contactNo || ''}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default BasicInfo;